import { state, actions, getters, mutations } from '../base/index'
import { uploadFile } from '@/store/modules/courses/file'
import rols from '@/store/modules/rols'

const courses = {
  namespaced: true,
  state: Object.assign({}, state),
  mutations: Object.assign({}, mutations),
  actions: Object.assign({}, actions),
  getters: Object.assign({}, getters)
}

courses.state.type = 'curso'
courses.state.type2 = 'curso'
courses.state.url = 'course/'
courses.state.file = ''
courses.actions.setUpload = ({ commit }, file) => {
  uploadFile(commit, file)
}
courses.actions.clearFile = ({ commit }) => commit('uploadFile', '')
courses.mutations.uploadFile = ({ state }, file) => state.file = file
courses.actions.setClone = ({ dispatch }, one) => {
  delete one._id
  delete one.createdBy
  delete one.createdAt
  one.name.forEach(item => item.text += '_copy')
  dispatch('setNew', one)
}
export default courses
